import {
  CalibrationPayload,
  CertificateUploadResponse,
  CreateDevicePayload,
  DeviceItem,
  DeviceListResponse,
  DeviceProfileListResponse,
  DeviceStatistics,
  EventListResponse,
  MetricListResponse,
  UpdateDevicePayload,
} from "entities/devices";
import { DELETE, GET, PATCH, POST } from "utils/http";

const baseUrl = "/api/devices";

const noRedirect = { skipAuthRedirect: true };

export const getList = (query = "") =>
  GET<DeviceListResponse>(`${baseUrl}${query}`, noRedirect);

export const getStatistics = (query = "") =>
  GET<DeviceStatistics>(`${baseUrl}/statistics${query}`, noRedirect);

export const getProfiles = () =>
  GET<DeviceProfileListResponse>(`${baseUrl}/profiles`, noRedirect);

export const getCurrent = (devEui: string) =>
  GET<DeviceItem>(`${baseUrl}/${devEui}`, noRedirect);

export const getMetrics = (devEui: string, query = "") =>
  GET<MetricListResponse>(`${baseUrl}/${devEui}/metrics${query}`, noRedirect);

export const getEvents = (devEui: string, query = "") =>
  GET<EventListResponse>(`${baseUrl}/${devEui}/events${query}`, noRedirect);

export const create = (payload: CreateDevicePayload) =>
  POST<CreateDevicePayload, DeviceItem>(baseUrl, payload, noRedirect);

export const update = (devEui: string, payload: UpdateDevicePayload) =>
  PATCH<UpdateDevicePayload, DeviceItem>(`${baseUrl}/${devEui}`, payload, noRedirect);

export const remove = (devEui: string) => DELETE(`${baseUrl}/${devEui}`, noRedirect);

export const uploadCertificate = (devEui: string, file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  return POST<FormData, CertificateUploadResponse>(
    `${baseUrl}/${devEui}/certificate`,
    formData,
    {
      ...noRedirect,
      headers: { "Content-Type": "multipart/form-data" },
    },
  );
};

export const deleteCertificate = (devEui: string) =>
  DELETE(`${baseUrl}/${devEui}/certificate`, noRedirect);

export const markCalibration = (devEui: string, payload: CalibrationPayload) => {
  const formData = new FormData();
  formData.append("calibrated_at", payload.calibrationDate);
  if (payload.calibratedBy) formData.append("calibrated_by", payload.calibratedBy);
  if (payload.certificate) formData.append("file", payload.certificate);
  return POST<FormData, DeviceItem>(`${baseUrl}/${devEui}/calibrations`, formData, {
    ...noRedirect,
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const recognizeEui = (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  return POST<FormData, { dev_eui: string | null }>(
    `${baseUrl}/recognize-eui`,
    formData,
    {
      ...noRedirect,
      headers: { "Content-Type": "multipart/form-data" },
    },
  );
};

export const recognizeAppKey = (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  return POST<FormData, { app_key: string | null }>(
    `${baseUrl}/recognize-app-key`,
    formData,
    {
      ...noRedirect,
      headers: { "Content-Type": "multipart/form-data" },
    },
  );
};
